import { Component, ComponentFactoryResolver, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { RightBarComponentDirective } from './rightBarComponentDirective';
import { SideBarComponentInterface } from './sideBarComponentInterface';

@Component({
  selector: 'app-dynamic-right-sidebar',
  templateUrl: './dynamic-right-sidebar.component.html',
  styleUrls: ['./dynamic-right-sidebar.component.scss']
})
export class DynamicRightSidebarComponent implements OnInit {

  @ViewChild(RightBarComponentDirective, { static: true }) host: RightBarComponentDirective;

  opened: boolean = false;
  title: string = "...";
  onClose$: EventEmitter<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private commonService: CommonService) { }

  ngOnInit() {


    this.commonService.rightSideBarComponent$.subscribe(
      (sideBarInititializeData) => {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(sideBarInititializeData.componentType);
        const viewContainerRef = this.host.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent<SideBarComponentInterface>(componentFactory);
        this.title = componentRef.instance.title;
        this.onClose$ = sideBarInititializeData.onClose;
        
        componentRef.instance.setData(sideBarInititializeData.data);
        this.opened = true;
      },
      (error) => { console.error(error); }
    );

    this.commonService.closeRightSideBar$.subscribe(
      (_) => { this.closeSidebar(); },
      (error) => { console.error(error); }
    );
  }

  closeSidebar() {
    this.opened = false;
    if(this.onClose$)
    {
      this.onClose$.emit();
    }
  }

}
